import { z } from 'zod';

const PaginationSchema = z.object({
  lastKey: z.string().optional().nullable(),
  limit: z.number().int().min(1).max(1000).default(200),
  nextToken: z.string().optional().nullable(),
});

const PaginatedResponseSchema = <T extends z.ZodType>(itemSchema: T) =>
  z.object({
    count: z.number().int().min(0),
    items: z.array(itemSchema),
    lastKey: z.string().optional().nullable(),
    nextToken: z.string().optional().nullable(),
  });

export const ReportSchema = z.object({
  cropSelectedTotal: z.boolean(),
  cropSummarize: z.boolean(),
  cropSummarizeName: z.string().nullable(),
  productSelectedTotal: z.boolean(),
  productSummarize: z.boolean(),
  productSummarizeName: z.string().nullable(),
  reportId: z.number().int().positive(),
  reportName: z.string(),
  reportNotes: z.string().nullable().optional(),
  reportUom: z.number().int(),
  stateSelectedTotal: z.boolean(),
  stateSummarize: z.boolean(),
  stateSummarizeName: z.string().nullable(),
  totalAllCrops: z.boolean(),
});

export type IReport = z.infer<typeof ReportSchema>;

export const ReportListQuerySchema = PaginationSchema.extend({
  region: z.string().optional(),
  reportName: z.string().optional(),
  state: z.string().optional(),
});

export type IReportListQuery = z.infer<typeof ReportListQuerySchema>;

export const ReportListResponseSchema = PaginatedResponseSchema(ReportSchema);

export type IReportListResponse = z.infer<typeof ReportListResponseSchema>;

export const UpdateReportNotesRequestSchema = z.object({
  notes: z.string().nullable(),
});

export type IUpdateReportNotesRequest = z.infer<
  typeof UpdateReportNotesRequestSchema
>;
